import ApplicationLayoutContainer from './ApplicationLayoutContainer';

export default ApplicationLayoutContainer;
